import React, {useEffect, useRef, useState} from 'react';
import './index.less';
import {message} from 'antd';
import cls from 'classnames';
import {addScript} from '../../../services/aigcScriptTool';
import {aiScriptToolLog} from '../../../log/aiScriptTool';
import EditorAILibModal from './EditorAILibModal';

const AIGCScriptTool = (props) => {
    const {headerTips} = props;
    const acScriptlibRef = useRef();
    const [showScriptListModal, setShowScriptListModal] = useState(false);
    const [currentScriptParams, setCurrentScriptParams] = useState({});
    function getIframeUrl() {
        if (location.hostname.includes('huibo-preview')) {
            return 'https:///huibo-preview.now.baidu.com/#/aiscripttool?fromapp=huibo';
        }
        return 'https://huibo.baidu.com/aiscripttool?fromapp=huibo';
    }

    const receiveMsgHandler = async (e) => {
        switch (e.data.type) {
            case 'SCRIPT-LIB-SAVE':
                const originParams = e.data.data?.originParams;
                const {data, errno, errmsg} = await addScript({
                    ...originParams,
                    ...e.data.data
                });
                if (errno === 0) {
                    acScriptlibRef.current?.contentWindow.postMessage({type: 'SCRIPT-LIB-SAVE-SUCCESS', data: {
                        ...data,
                        ...e.data.data
                    }}, '*');
                    const scriptContentAll = e.data.data?.contents.reduce((value, item) => {
                        return value + item.content + '\n';
                    }, '');
                    aiScriptToolLog('save', {
                        script_id: data?.id,
                        input: originParams?.input_type,
                        name: originParams?.goods_name,
                        price: originParams?.price,
                        people: originParams?.target_people,
                        goods_point: originParams?.goods_point,
                        user_point: originParams?.user_point,
                        benefit: originParams?.benefit,
                        activity: originParams?.activity,
                        time: e.data.data?.gen_time,
                        model_content: scriptContentAll, // ai生成内容
                        model_len: scriptContentAll?.length, // ai生成长度
                        product_id: originParams?.goods_id,
                        spu_id: originParams?.spu_id,
                        edit: e.data.data?.is_modify,
                        style: originParams?.follow_style
                    });
                    message.success(errmsg);
                }
                else {
                    acScriptlibRef.current?.contentWindow.postMessage({type: 'SCRIPT-LIB-SAVE-FAILED'}, '*');
                    message.error(errmsg);
                }
                break;
            case 'SCRIPT-LIB-MODAL-OPEN':
                const currentParams = e.data.data?.originParams;
                setCurrentScriptParams(currentParams);
                setShowScriptListModal(true);
                break;
            case 'SCRIPT-LIB-RESET':
                aiScriptToolLog('reset');
                break;
            case 'SCRIPT-LIB-GENERATE-RES':
                aiScriptToolLog('generate', {
                    ...e.data.data
                });
                break;
            case 'SCRIPT-LIB-DOWNLOAD':
                aiScriptToolLog('download', {
                    ...e.data.data
                });
                break;
            case 'SCRIPT-LIB-ERNIE-REGENERATE':
                aiScriptToolLog('regenerate', {
                    ...e.data.data
                });
                break;
            case 'SCRIPT-LIB-ERNIE-AIHELP': // 首次点击辅写 埋点数据
                aiScriptToolLog('aihelp', {
                    ...e.data.data
                });
                break;
            case 'SCRIPT-LIB-ERNIE-ACCEPT':
                aiScriptToolLog('accept', {
                    ...e.data.data
                });
                break;
            case 'SCRIPT-LIB-CONTENT-ITEM-DEL':
                aiScriptToolLog('delete', {
                    ...e.data.data
                });
                break;
            case 'SCRIPT-LIB-CONTENT-ITEM-COPY':
                aiScriptToolLog('copy', {
                    ...e.data.data
                });
                break;
            case 'SCRIPT-LIB-COPY-ALL':
                aiScriptToolLog('copy_all', {
                    ...e.data.data
                });
                break;
            case 'ASR_CLICK':
                aiScriptToolLog('asr_click');
                break;
            case 'ASR_CONVERT':
                aiScriptToolLog('asr_convert');
                break;
            case 'ASR_USER':
                console.log('ASR_USER', {
                    ...e.data.data
                });
                aiScriptToolLog('asr_user', {
                    ...e.data.data
                });
                break;
            default:
                break;
        }
    };
    useEffect(() => {

        window.addEventListener('message', receiveMsgHandler);
        return () => {
            removeEventListener('message', receiveMsgHandler);
        };
    }, []);
    return (
        <>
            <div
                className="scriptlib-container"
                style={headerTips ? {
                    height: 'calc(100vh - 56px - 46px)'
                } : {}}
            >
                <iframe ref={acScriptlibRef} src={getIframeUrl()}></iframe>
            </div>
            {showScriptListModal && <EditorAILibModal
                showScriptListModal={showScriptListModal}
                setShowScriptListModal={setShowScriptListModal}
                acScriptlibRef={acScriptlibRef}
                currentScriptParams={currentScriptParams}
                aiScriptToolLog={aiScriptToolLog}
            />}
        </>
    );
};
export default AIGCScriptTool;